import { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import {
    ClientDashboard,
    ClientList,
    AddClient,
    OnboardClient,
    OnboardingRequests,
    RecentActivity,
    ClientReports,
    ContactList
} from "./client-management";
import styles from "./ClientManagement.module.css";

const ClientManagement = () => {
    const { isDarkMode } = useTheme();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'Client Management';
    }, []);

    // Extract current section from pathname for breadcrumb
    const getBreadcrumbItems = () => {
        const path = location.pathname;
        if (path === '/clients') return ['Client Management'];
        if (path === '/clients/list') return ['Client Management', 'All Clients'];
        if (path === '/clients/add') return ['Client Management', 'Add Client'];
        if (path === '/clients/onboard') return ['Client Management', 'Onboard Client'];
        if (path === '/clients/onboarding-requests') return ['Client Management', 'Information Requests'];
        if (path === '/clients/recent') return ['Client Management', 'Recent Activity'];
        if (path === '/clients/reports') return ['Client Management', 'Reports'];
        if (path === '/clients/contacts/list') return ['Client Management', 'All Contacts'];
        return ['Client Management'];
    };

    const breadcrumbItems = getBreadcrumbItems();
    const isOnDashboard = location.pathname === '/clients';

    return (
        <div className={styles.clientManagement}>
            <div className={styles.header}>
                <h1>Client Management</h1>
                <nav className={styles.breadcrumb}>
                    {breadcrumbItems.map((item, index) => (
                        <span key={index}>
                            {index === 0 ? (
                                <button 
                                    className={`${styles.breadcrumbItem} ${isOnDashboard ? styles.active : ''}`}
                                    onClick={() => navigate('/clients')}
                                >
                                    {item}
                                </button>
                            ) : index === breadcrumbItems.length - 1 ? (
                                <span className={`${styles.breadcrumbItem} ${styles.active}`}>
                                    {item}
                                </span>
                            ) : (
                                <button 
                                    className={styles.breadcrumbItem}
                                    onClick={() => {
                                        if (item === 'All Clients') navigate('/clients/list');
                                    }}
                                >
                                    {item}
                                </button>
                            )}
                            {index < breadcrumbItems.length - 1 && (
                                <span className={styles.breadcrumbSeparator}>›</span>
                            )}
                        </span>
                    ))}
                </nav>
            </div>

            <div className={styles.content}>
                <Routes>
                    <Route index element={<ClientDashboard />} />
                    <Route path="list" element={<ClientList />} />
                    <Route path="add" element={<AddClient />} />
                    <Route path="onboard" element={<OnboardClient />} />
                    <Route path="onboarding-requests" element={<OnboardingRequests />} />
                    <Route path="recent" element={<RecentActivity />} />
                    <Route path="reports" element={<ClientReports />} />
                    <Route path="contacts/list" element={<ContactList />} />
                </Routes>
            </div>
        </div>
    );
};

export default ClientManagement;